import LoadingMixin from "@/mixins/LoadingMixin";
import mixins from "vue-typed-mixins";
import { throttle } from "lodash";

const infiniteScroll = require("vue-infinite-scroll");

//v-infinite-scroll will call load-more if the bottom of the bound element is in view port
//in that case, it is fired almost at the same time as the MOUNTED event.
//but if the bottom is not visible (when viewport is really small, load-more will not be called automatically)
//To make sure that the FIRST PAGE is always called regardless if the bottom is in view port or not
//we will always call this.doLoadMore in the concrete component and we will throttle `this.doLoadMore`
//so most of the time, doLoadMore will be called ONCE on MOUNTED.
const THROTTLE_INTERVAL = 500;

// see https://forum.vuejs.org/t/using-mixins-with-typescript/24256/6
const InfiniteScrollMixin = mixins(LoadingMixin).extend({
  directives: {
    infiniteScroll,
  },
  data() {
    return {
      isEmpty: false,
      busyLoading_: false,
      firstPageInitialized_: false,
      nextCursor_: undefined as undefined | null | number,
    };
  },
  computed: {
    canLoadMore(): boolean {
      return !this.firstPageInitialized_ || Boolean(this.nextCursor_);
    },
    shouldDisableInfiniteScroll(): boolean {
      return !this.canLoadMore;
    },
  },
  created() {
    this.doLoadMore = throttle(this.doLoadMore, THROTTLE_INTERVAL, {
      leading: true,
      trailing: false,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any;
  },
  methods: {
    async doLoadMore(
      action: (cursor: {
        CurrentCursor: number | undefined;
        IsFirstPage: boolean;
      }) => Promise<{ NextCursor: number | null | undefined }>,
    ) {
      if (this.busyLoading_) return;
      this.busyLoading_ = true;
      try {
        if (!this.canLoadMore) return;
        await this.withLoading(async () => {
          const res = await action({
            CurrentCursor: this.nextCursor_ || undefined,
            IsFirstPage: !this.firstPageInitialized_,
          });
          this.nextCursor_ = res.NextCursor;
          if (!this.firstPageInitialized_) {
            this.isEmpty = !res.NextCursor;
          }
          this.firstPageInitialized_ = true;
        });
      } finally {
        this.busyLoading_ = false;
      }
    },
  },
});

export default InfiniteScrollMixin;
